.atm_e2_1osqo2v{height:100%;}
.atm_vy_1osqo2v{width:100%;}
.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_fc_esu3gu.atm_fc_esu3gu{justify-content:flex-end;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
